import { Injectable } from '@angular/core';
import { ApiClient } from '../../core/api-client.service';
import { GetInvoicesRequest } from './DTOs/get-invoices-request';
import { MemberInvoicesDtRetInfo } from './DTOs/member-invoices-dt-ret-info';
import { Observable } from 'rxjs';
import { DumbInvoice } from './DTOs/dumb-invoice';
import { DumbPaymentMethod } from '../membership-management/DTOs/dumb-payment-method';
import { SubmitPaymentRequest } from './DTOs/submit-payment-request';

@Injectable({
  providedIn: 'root'
})
export class MemberInvoicesService {
  readonly relativeBase = "member-admin-invoice-management/";

  constructor(private http: ApiClient) {

  }
  submitNonInvoicePayment(request: SubmitPaymentRequest): Observable<boolean> {
    return this.http.post(this.relativeBase + "submit-non-invoice-payment", request);
  }
  searchMemberInvoices(request: GetInvoicesRequest): Observable<MemberInvoicesDtRetInfo> {
    return this.http.post(this.relativeBase + "search-all", request);
  }
  selectAllInvoices(request: GetInvoicesRequest): Observable<DumbInvoice[]> {
    return this.http.post(this.relativeBase + "select-all", request);
  }
  getInvoicesListForPaying(request: number[]): Observable<DumbInvoice[]> {
    return this.http.post(this.relativeBase + "invoices-for-paying", request);
  }
  getMemberPaymentMethod(): Observable<DumbPaymentMethod>{
    return this.http.get(this.relativeBase + "member-payment-method");
  }
  submitPayment(request: SubmitPaymentRequest): Observable<boolean> {
    return this.http.post(this.relativeBase + "submit-invoice-payment", request);
  }
}
